module.exports = __webpack_public_path__ + "img/ARCH.2c92f460.svg";